exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "adp-status-icon{display:block}adp-status-icon .material-icons{display:flex;align-items:center;justify-content:center;width:16px;height:16px;color:#fff;background-color:#008c00;border-radius:50%;font-size:12px}adp-status-icon .material-icons.success{background-color:#008c00}adp-status-icon .material-icons.error{background-color:#d40f0f}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/app/components/adpStatusIcon/adpStatusIcon.less
// module id = 696
// module chunks = 0